import React, { Component } from 'react';
import { message } from 'antd';
import MachineAddView from '../views/MachineAddView';
import { base } from '../../base';
import moment from 'moment';

class MachineAddContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            machine: null,
        };
        this.handleCreate = this.handleCreate.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.machineRef = null;
    }

    componentDidMount() {
        if (this.props.machineId) {
            this.machineRef = base.syncState(`machines/${this.props.extraUser.companyid}/${this.props.machineId}`, {
                context: this,
                state: 'machine',
            });
        }
    }

    componentWillUnmount() {
        if (this.machineRef != null) {
            base.removeBinding(this.machineRef);
        }
    }

    handleCreate(values) {
        if (this.props.machineId) {
            this.handleUpdate(values);
        } else {
            const { closeForm } = this.props;
            // let time = moment().add(values.dayscheck, 'days').calendar();
            base.push(`machines/${this.props.extraUser.companyid}/`, {
                data: {
                    companyid: 0,
                    name: values.name,
                    status: values.status,
                    brand: values.brand,
                    model: values.model,
                    serial: values.serial,
                    year: values.year,
                    price: values.machinePrice,
                    dayscheck: values.dayscheck,
                    lastcheck: moment().format('YYYY-MM-DD'),
                    // service: values.service.format('YYYY-MM-DD'),
                },
                then(err) {
                    if (!err) {
                        message.success('Maquina creada exitosamente');
                        closeForm();
                    }
                },
            });
        }
    }

    handleUpdate(values) {
        const { closeForm } = this.props;
        // let time = moment().add(values.dayscheck, 'days').calendar();
        base.update(`machines/${this.props.extraUser.companyid}/${this.props.machineId}`, {
            data: {
                companyid: this.props.extraUser.companyid,
                name: values.name,
                status: values.status,
                brand: values.brand,
                model: values.model,
                serial: values.serial,
                year: values.year,
                location: values.location,
                price: values.machinePrice,
                dayscheck: values.dayscheck,
                lastcheck: moment().format('YYYY-MM-DD'),
                // service: values.service.format('YYYY-MM-DD'),
            },
            then(err) {
                if (!err) {
                    message.success('Maquina actualizada exitosamente');
                    closeForm();
                }
            },
        });
    }

    render() {
        console.log(this.props.machineId);
        return (
            <MachineAddView
                machine={this.state.machine}
                openForm={this.props.openForm}
                onCancel={this.props.onCancel}
                handleCreate={this.handleCreate}
            />
        );
    }
}

export default MachineAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineAddContainer.js